"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z.object({
    location: zod_1.z.object({
        timestamp: zod_1.z.number(),
        coords: zod_1.z.object({
            latitude: zod_1.z.number(),
            longitude: zod_1.z.number(),
        }),
    }),
});
exports.default = new ItemDefinition_1.ItemDefinition("Location", configSchema, dataSchema, new validation_1.ValidatorPipeline("Location Config Validator", []), new validation_1.ValidatorPipeline("Location Data Validator", []));
//# sourceMappingURL=Location.js.map